import { getCountries, getReferers, getCivilities, getMemberProfile, getPhoneExtension, getZipData, updateMemberProfile} from './../api/index';
import { useState, useEffect, useRef } from 'react';
import { useQuery } from 'react-query';
import MyModal from "./MyModal";
import ReactTooltip from "react-tooltip";
import * as DOMPurify from 'dompurify';
import Spinner from "./Spinner";
import './FormPremium.css';

import { Formik, Field, Form } from "formik";
import * as Yup from 'yup';

const FormPremium = (props) => {

    const { data: dataCountries } = useQuery(['countries'], async () => await getCountries());
    const countries = dataCountries || {};
    
    const { data: dataReferers } = useQuery(['referers'], async () => await getReferers());
    const referersList = dataReferers || {};
    
    const { data: dataCivilities } = useQuery(['civilities'], async () => await getCivilities());
    const civilities = dataCivilities || {};

    const { data: initialProfile } = useQuery(['profile'], async () => await getMemberProfile());

    const dataIndicatif = useRef({
        indicative: "+33"
    });

    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [err, setErr] = useState(false);
    const [zipData, setZipData] = useState([]);

    useEffect(() => {
        const fetchData = async (countryCode) => {
            const data = await getPhoneExtension(countryCode);
            dataIndicatif.current = data;
        }
        const countryCode = initialProfile ? initialProfile.addresses.postal.country.code : 'FR';
        fetchData(countryCode);
    }, [initialProfile]);

    const handleChangeCountry = async (e, formikProps) => {
        const code = e.target.value;
        const phoneExt = await getPhoneExtension(code);
        formikProps.setFieldValue('phoneExt', phoneExt.indicative);
        formikProps.setFieldValue('country', code);
    }

    const handleOnClickZipData = (formikProps, zipDataElt) => {
        formikProps.setFieldValue('zip', zipDataElt.zip_code);
        formikProps.setFieldValue('city', zipDataElt.zip_city);
        setZipData([]);
    }

    const hideParentModal = () => {
        window.jQuery('#modalInscriptionPremium').modal('hide');
    }

    const handleClose = () => {
        setShowModal(false);
        window.location.reload(false);
    }

    const getModalData = () => {
        let title = `Passer Membre Premium`;
        let message = `<p>Félicitations !</p>
            <p>Vous êtes désormais Membre Premium.<span class="help-premium-picto"><img src="/bundles/boursedirecttheme/images/boursedirect/ui/crown-32.png"></span></p>
            <p>Vous pourrez profiter de vos nouveaux avantages dans quelques secondes.</p>
            <p>A tout de suite.</p>`;
        
        if (props.context !== "modal") {
            title = `Informations Personnelles`;
            message = `Les modifications que vous avez apportées ont bien été prises en compte.`;
        }

        return {
            title: title,
            body: err ? "Une erreur est survenue. Veuillez réessayer ultérieurement." : <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message) }} />
        }
    }

    const sleep = ms => new Promise(r => setTimeout(r, ms));

    const handleSubmit = async (values) => {
        setIsLoading(true);
 
        const data = {
            civility: values.civility,
            first_name: values.firstname,
            last_name: values.lastname,
            phone: values.phone ? values.phoneExt + values.phone.replace(/^./, "") : "",
            address: {
                street_number: values.address ? values.address.split(" ")[0] : "",
                street_extension: "",
                street_name: values.address ? values.address.slice(values.address.split(" ")[0].length + 1, values.address.length) : "",
                country: values.country,
                city: {
                    name: values.city,
                    zipcode: values.zip
                }
            },
            known_by: values.known_by ? values.known_by : null,
            has_portfolio: values.has_portfolio ? values.has_portfolio : false,
            partners_offers: values.partners_offers ? values.partners_offers : null
        }

        try {
            const result = await updateMemberProfile(data);

            if (result.status === 200) {
                setErr(false);
            } else {
                setErr(true);
            }
        } catch (error) {
            setErr(true);
        } finally {
            if (props.context === 'modal') {
                hideParentModal();
            }

            await sleep(500);
            setIsLoading(false);
            setShowModal(true);
        }
    }

    const initialValues = {
        civility: initialProfile ? initialProfile.civility : "",
        lastname: initialProfile ? initialProfile.last_name : "",
        firstname: initialProfile ? initialProfile.first_name : "",
        address: initialProfile ? initialProfile.addresses.postal.street : "",
        zip: initialProfile ? initialProfile.addresses.postal.city.zipcode : "",
        city: initialProfile ? initialProfile.addresses.postal.city.name : "",
        phone: initialProfile && initialProfile.mobile ? "0"+initialProfile.mobile.slice(-9) : "",
        // known_by: initialProfile ? initialProfile.known_by : "",
        phoneExt: dataIndicatif && dataIndicatif.current.indicative ? dataIndicatif.current.indicative : "+33",
        country: initialProfile && initialProfile.addresses.postal.country.code ? initialProfile.addresses.postal.country.code : "FR",
        // has_portfolio: initialProfile ? initialProfile.has_portfolio : false,
        // partners_offers: initialProfile ? initialProfile.partners_offers : false
    };

    const objectSchemaSimple = {
        civility: Yup.string()
            .required("Ce champ est obligatoire"),
        lastname: Yup.string().nullable()
            .min(2, "trop petit")
            .max(32, "trop long!")
            .required("Ce champ est obligatoire"),
        firstname: Yup.string().nullable()
            .min(2, "trop petit")
            .max(32, "trop long!")
            .required("Ce champ est obligatoire"),
        address: Yup.string().nullable()
            .min(3, "trop petit")
            .max(128, "trop long!"),
            // .required("Ce champ est obligatoire"),
        zip: Yup.string().nullable()
            .min(2, "trop petit")
            .max(10, "trop long!")
            .required("Ce champ est obligatoire"),
        city: Yup.string().nullable()
            .min(2, "trop petit")
            .max(20, "trop long!")
            .required("Ce champ est obligatoire"),
        phone: Yup.string().nullable()
            .matches(/(^(0[1-9]{1}[0-9]{8}|[1-9]{1}[0-9]{8})$)/, "Format du télépone invalide")
    }
    const objectSchema = props.context !== "modal" ? objectSchemaSimple : {
        ...objectSchemaSimple,
        known_by: Yup.string()
            .required("Ce champ est obligatoire"),
        consent: Yup.boolean()
            .oneOf([true], "Ce champ doit être coché")
            .required("Ce champ doit être coché")
    }
    const validationSchema = Yup.object().shape(objectSchema);
    
    const handleClickDisplayLegalNoticeModal = () => {
        window.open("espace-membre/premium/mentions-legales", "_blank");
    }
        
    const renderForm = (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
                handleSubmit(values);
            }}
        >
            {formikProps => (
                <Form onSubmit={formikProps.handleSubmit} noValidate>
                    <div className="row">
                        <div className='col-md-3 bloc form-group champ'>
                            <label>Civilité * :</label>
                            <Field  
                                as="select" 
                                id="civility" 
                                name="civility" 
                                className={formikProps.errors.civility ? "err": ""} 
                                data-tip={formikProps.errors.civility ? formikProps.errors.civility : ""} 
                                data-for="civility"
                                value={formikProps.values.civility}
                                onChange={formikProps.handleChange}
                                required
                            >
                                <option value="">Choisissez</option>
                                {Object.entries(civilities).map(([key,value],i) => <option key={i} value={key} >{value}</option> )}
                            </Field >
                            <ReactTooltip id="civility" place="bottom" backgroundColor="red" effect="solid" disable={!formikProps.errors.civility} />
                        </div>
                        <div className='col-md-4 bloc form-group champ'>
                            <label>Nom * :</label>
                            <Field
                                required
                                type="text"
                                data-tip={formikProps.errors.lastname ? formikProps.errors.lastname : ""}
                                data-for="lastname"
                                placeholder="Ex: Dubois"
                                id="lastname"
                                name="lastname"
                                className={formikProps.errors.lastname ? "err" : ""}
                                value={formikProps.values.lastname}
                                onChange={formikProps.handleChange}
                            />
                            <ReactTooltip id="lastname" place="bottom" backgroundColor="red" effect="solid" disable={!formikProps.errors.lastname} />
                        </div>
                        <div className='col-md-5 bloc form-group champ'>
                            <label>Prénom * :</label>
                            <Field
                                required
                                type="text"
                                data-tip={formikProps.errors.firstname ? formikProps.errors.firstname : ""}
                                data-for="firstname"
                                placeholder="Ex: Marc"
                                id="firstname"
                                name="firstname"
                                className={formikProps.errors.firstname ? "err" : ""}
                                value={formikProps.values.firstname}
                                onChange={formikProps.handleChange}
                            />
                            <ReactTooltip id="firstname" place="bottom" backgroundColor="red" effect="solid" disable={!formikProps.errors.firstname} />
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-md-5 bloc form-group champ'>
                            <label>Adresse :</label>
                            <Field
                                required
                                type="text"
                                placeholder="Ex: 19 rue Watteau"
                                name="address"
                                value={formikProps.values.address}
                                onChange={formikProps.handleChange}
                            />
                        </div>
                        <div className='col-md-4 bloc form-group champ'>
                            <label>Code Postal * :</label>
                            <Field
                                type="text"
                                data-tip={formikProps.errors.zip ? formikProps.errors.zip : ""}
                                data-for="zip"
                                placeholder="Ex: 75001"
                                value={formikProps.values.zip}
                                onChange={async (e) => {
                                    formikProps.handleChange(e);
                                    const zip = e.target.value;
                                    if (zip.length > 2) {
                                        const zipData = await getZipData(zip);
                                        setZipData(zipData);
                                    }
                                }}
                                autocomplete="off"
                                name="zip"
                                className={formikProps.errors.zip ? "err" : ""}
                                disabled={!(props.context === "modal")}
                                required
                            />
                            <ReactTooltip id="zip" place="bottom" backgroundColor="red" effect="solid" disable={!formikProps.errors.zip} />
                            { formikProps.values.country === 'FR' ? (
                                <div className='auto-container'>
                                    {zipData && zipData.map((el, i) => 
                                        <div className='zip-data' key={i} onClick={() => handleOnClickZipData(formikProps, el)}>{el.zip_code} {el.zip_city}</div>
                                    )}
                                </div>
                            ) : (
                                    null
                            )}
                            
                        </div>
                            <div className='col-md-3 bloc form-group champ'>
                            <label>Ville * :</label>
                            <Field
                                required
                                type="text"
                                data-tip={formikProps.errors.city ? formikProps.errors.city : ""}
                                data-for="city"
                                placeholder="Ex: Paris"
                                name="city"
                                className={formikProps.errors.city ? "err" : ""}
                                value={formikProps.values.city}
                                onChange={formikProps.handleChange}
                                disabled={!(props.context === "modal") || formikProps.values.country === 'FR' ? true : false}
                            />
                            <ReactTooltip id="city" place="bottom" backgroundColor="red" effect="solid" disable={!formikProps.errors.city} />
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-md-5 bloc form-group champ'>
                            <label>Pays * :</label>
                            <Field as="select" name="country" onChange={(e)=> handleChangeCountry(e, formikProps)} disabled={!(props.context === "modal")}>
                                {Object.entries(countries).map(([key,value],i) => <option key={i} value={key}>{value}</option>)}
                            </Field>
                        </div>
                        <div className='col-md-2 bloc form-group champ'>
                            <label>Indicatif :</label>
                            <Field
                                required
                                type="text"
                                placeholder="Ex: +33"
                                name="phoneExt"
                                value={formikProps.values.phoneExt}
                                onChange={formikProps.handleChange}
                                disabled={true}
                            />
                        </div>
                        <div className='col-md-5 bloc form-group champ'>
                            <label>Téléphone :</label>
                            <Field
                                required
                                type="tel"
                                placeholder="Ex: 0122443050"
                                name="phone"
                                value={formikProps.values.phone}
                                onChange={formikProps.handleChange}
                                className={formikProps.errors.phone ? "err" : ""}
                                data-tip={formikProps.errors.phone ? formikProps.errors.phone : ""} 
                                data-for="phone"
                            />
                            <ReactTooltip id="phone" place="bottom" backgroundColor="red" effect="solid" disable={!formikProps.errors.phone} />
                        </div>
                    </div>
                    {props.context === 'modal' &&
                    <div className="row">
                        <div className='col-md-12 bloc form-group champ'>
                            <label>Comment nous avez-vous connu ? * :</label>
                            <Field 
                                as="select" 
                                id="known_by" 
                                name="known_by" 
                                data-tip={formikProps.errors.known_by ? formikProps.errors.known_by : ""} 
                                data-for="known_by"
                                className={formikProps.errors.known_by ? "err" : ""}
                                onChange={formikProps.handleChange}
                            >
                                <option value="">Choisissez</option>
                                {Object.entries(referersList).map(([key,value],i) => <option key={i} value={key} >{value}</option> )}
                            </Field>
                            <ReactTooltip id="known_by" place="bottom" backgroundColor="red" effect="solid" disable={!formikProps.errors.known_by} />
                        </div>
                    </div>
                    }
                    {props.context === 'modal' &&
                    <div class="row">
                        <div class="col-md-12">
                            <div class="checkbox-inline no-padding-left">
                                <div class="input-checkbox cg-member-chk">
                                    <Field
                                        type="checkbox"
                                        id="has_portfolio"
                                        name="has_portfolio"
                                        onChange={formikProps.handleChange}
                                    />
                                    <span></span> <label className="wrap" for="has_portfolio">J'ai déjà un portefeuille boursier</label></div>
                                <div class="input-checkbox cg-member-chk">
                                    <Field
                                        type="checkbox"
                                        id="partners_offers"
                                        name="partners_offers"
                                        onChange={formikProps.handleChange}
                                    />
                                    <span></span> <label className="wrap" for="partners_offers">Je souhaite recevoir les offres partenaires de Bourse Direct</label></div>
                                <div class="input-checkbox align-justify cg-member-chk">
                                    <Field
                                        type="checkbox"
                                        data-tip={formikProps.errors.consent ? formikProps.errors.consent : ""}
                                        data-for="consent"
                                        id="consent"
                                        name="consent"
                                        className={formikProps.errors.consent ? "err-chk" : "e"}
                                        required
                                    />
                                    <span></span> <label className="wrap" for="consent"><b>J'ai pris connaissance des informations concernant <a href="#" className="color-a" target="_blank" onClick={handleClickDisplayLegalNoticeModal}>les traitements de mes données</a> à caractère personnel et de mes droits associés et j'accepte que les informations fournies soient utilisées par Bourse Direct pour me communiquer des informations sur son offre et services. Je peux retirer mon consentement. *</b></label>
                                    <ReactTooltip id="consent" place="bottom" backgroundColor="red" effect="solid" disable={!formikProps.errors.consent} />
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    <div class="row">
                        <div class="col-md-12 footer-form">
                            <p class="color-c"><b><i>*information obligatoire</i></b></p>
                            <button type="submit" id="validate" name="validate" class="btn btn-default">Enregistrer</button>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    )

    return (
        <>
            {isLoading ? <Spinner /> : renderForm}
            <MyModal
                show={showModal}
                handleClose={handleClose}
                bodyText={getModalData().body}
                titleText={getModalData().title}
            />
        </>
    );
}

export default FormPremium;
